<template>
    <div class="container" :style="{'min-height': height+'px'}">
        <div class="tle">
            <router-link to="/user"><span><i class="iconfont">&#xe703;</i>帮人报名</span></router-link>
        </div>
        <div class="content" v-if="data.length">
            <div class="cards" v-for="item in data" :key="item.id">
                <img v-if="item.head_path" :src="item.head_path | img_url_finish" class="avatar">
                <img v-else :src="$store.state.static_img_url+'/img/default-head-img.png'" class="avatar">
                <p><span class="key">姓名：</span><span class="value">{{item.name}}</span></p>
                <p><span class="key">姓名拼音：</span><span class="value">{{item.spell_last_name + ' ' + item.spell_first_name}}</span></p>
                <p><span class="key">手机号：</span><span class="value red">{{item.mobile}}</span></p>
                <p><span class="key">邮箱：</span><span class="value">{{item.email}}</span></p>
                <p><span class="key">所在地区：</span><span class="value">{{item.province | dealName(area)}}{{item.city| dealName(area)}}{{item.county| dealName(area)}}</span></p>
                <p><span class="key">地址：</span><span class="value">{{item.address}}</span></p>
                <p><span class="key">单位名称：</span><span class="value">{{item.organization}}</span></p>
                <p><span class="key">科室/部门：</span><span class="value">{{item.department}}</span></p>
                <p><span class="key">单位电话：</span><span class="value">{{item.department_phone | empty('未填写')}}</span></p>
                <p><span class="key">职称：</span><span class="value">{{item.hos_title_id | dealName(hos_title)}}</span></p>
                <!-- <p><span class="key">状态：</span><span class="value">{{item.status == '0' ? '审核中':'已审核'}}</span></p> -->
                <div class="option">
                    <router-link :to="{ name:'ApplyForOther',  params:{ info: item }, query: {edit: true}}" class="btn">修改</router-link>
                    <!-- <span v-else class="btn btn-disable">修改</span> -->
                </div>
            </div>
        </div>
        <div v-else class="no-data">
            <img src="~mpic/no-favorite.png">
            <p>暂无数据</p>
        </div>

        <div class="option-div">
            <router-link to="/applyForOther" class="btn">帮人报名</router-link>
        </div>
    </div>
</template>

<script>
import { getUserActivityList,getMeta } from '../../../service'

export default {
    data(){
        return {
            height:0,
            data: [], //请求回来的数据
            area:[], //地区
            hos_title:[] //职称
        }
    },
    computed: {
        user_key() {
            return this.$store.state.user_key
        },
        activity_id(){
            return this.$store.state.activity_id
        }
    },
    methods:{
        async getList(){
            let res = await getUserActivityList({ user_key: this.user_key, activity_id: this.activity_id }, (error) => {this.$Message.error('请求错误!')})
            let meta_res = await getMeta({ name:['area','hos_title'] })
            this.area = meta_res.meta.area
            this.hos_title = meta_res.meta.hos_title
            this.data = res.apply_user_list
        },
    },

    created(){
        this.getList()
    },
    mounted() {
      this.height = document.documentElement.clientHeight + ''
    }
}
</script>

<style lang="stylus" scoped>
@import '../styles/common.styl'

    .content
        margin-bottom: 2.05rem
        margin-top: 1.18rem;
        .cards
            position: relative
            margin-top: .3rem
            line-height: .36rem
            padding: .27rem .35rem
            background: #ffffff
            border-radius: .1rem
            .key
                color: #999999
            .value
                color: #333333
                font-weight: bold
            .red
                color: #E12222
            p + p
                margin-top:.25rem
            .avatar
                position: absolute
                right: .3rem
                width:1rem
                height:1rem
                border-radius:50%
            .option
                margin-top: .3rem
                padding-top: .3rem
                border-top: 1px solid #EEEEEE
                .btn
                    float: right
                    padding: .08rem .25rem
                    border:1px solid rgba(225,34,34,1)
                    border-radius: .3rem
                    font-size: .26rem
                    color:rgba(225,34,34,1)
                    line-height: .22rem
                .btn-disable
                    border:1px solid #999999
                    color: #999999
                &::after
                    content:""
                    clear:both
                    display:block
</style>
